
/*
 * VNCtask : VNCtask – the easy to use Task Management & To-Do List application. Stay organized. Anytime! Anywhere!
 * Copyright (C) 2015-2020 VNC – Virtual Network Consult AG (info@vnc.biz)
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published by
 * the Free Software Foundation, version 3 of the License.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE. See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program. Look for COPYING file in the top folder.
 * If not, see http://www.gnu.org/licenses/.
 */

import { Component, OnChanges, Input, Output, EventEmitter, ViewChild, OnDestroy, ChangeDetectionStrategy, ChangeDetectorRef, inject } from "@angular/core";
import { BulkUpdateIssueType } from "../../shared/task-enum";
import { TasksRootState, getAuthUser, getProjectsList } from "../../store/index";
import { Store } from "@ngrx/store";
import { ResponsiveService } from "../../../common/providers/responsive.service";
import { Project } from "../../models";
import { takeWhile } from "rxjs/operators";
import { VNCCheckboxComponent } from "@uxf/vnc-library";
import { MatTooltip } from "@angular/material/tooltip";
import { MatMenuTrigger, MatMenu } from "@angular/material/menu";
import { MatList, MatListItem } from "@angular/material/list";
import { MatIcon } from "@angular/material/icon";
import { TranslatePipe } from "@ngx-translate/core";

@Component({
    selector: "vp-vnctask-header-menubar",
    templateUrl: "task-header-menubar.html",
    imports: [VNCCheckboxComponent, MatTooltip, MatMenuTrigger, MatMenu, MatList, MatListItem, MatIcon, TranslatePipe]
})
export class TaskHeaderMenubarComponent implements OnChanges, OnDestroy {
  private responsiveService = inject(ResponsiveService);
  private store = inject<Store<TasksRootState>>(Store);
  private changerDetectorRef = inject(ChangeDetectorRef);

  @ViewChild("taskContextTrigger", { static: false }) contextPopoverTrigger: MatMenuTrigger;
  @Input() totalCount;
  @Input() isSearchMode;
  @Input() selectedTasksIds: number[] = [];
  @Input() selectAll: boolean = false;
  @Input() isChangeUserOptionVisible: boolean = true;
  @Output() menuItemClick = new EventEmitter<object>();
  public bulkUpdateIssueType = BulkUpdateIssueType;
  screen: string = this.responsiveService.getScreen();
  isAlive: boolean = true;
  authUser: any = {};
  projectList: Project[] = [];

  constructor() {
    this.store.select(getAuthUser).pipe(takeWhile(() => this.isAlive)).subscribe(user => {
      if (user) {
        this.authUser = user;
        this.changerDetectorRef.markForCheck();
      }
    });
    this.store.select(getProjectsList).pipe(takeWhile(() => this.isAlive)).subscribe( projects => {
      this.projectList = projects;
      this.changerDetectorRef.markForCheck();
    });
   }

  ngOnChanges(changes) { }

  closeContextMenu(): void {
    if (this.contextPopoverTrigger?.menuOpen) {
      this.contextPopoverTrigger.closeMenu();
    }
  }

  ngOnDestroy(): void {
    this.isAlive = false;
    (this.menuItemClick as any).unsubscribe();
  }

  updateSelectAll () {
    this.selectAll = !this.selectAll;
  }
}
